import { analysInfo } from "@/core/yiguan-sdk/index";
import * as AnalysysAgent from "AnalysysAgent";

interface PropertyType {
  userId: string;
  zuhu_id?: string;
  zuhu_name?: string;
  bumen_name?: string;
  juese_name?: string;
}

interface UserType {
  user_account?: string;
  user_name?: string;
}

export function setUserProperty(property: PropertyType, userInfo?: UserType) {
  const { AnalysysAgent } = analysInfo;
  if (analysInfo.hasAlias) return;

  let { userId, ...properties } = property;
  if (userId) AnalysysAgent?.alias(userId);
  properties = Object.keys(properties).reduce((total, ele) => {
    if (properties[ele]) {
      total[ele] = properties[ele];
    }
    return total;
  }, {});
  AnalysysAgent?.registerSuperProperty(properties);
  AnalysysAgent?.profileSet(userInfo);
  analysInfo.hasAlias = true;
}

export function resetAnalys() {
  // 重置埋点
  AnalysysAgent?.default?.clearSuperProperties();
  AnalysysAgent?.default?.reset();
  analysInfo.hasAlias = false;
}
